import Layout from '../components/Layout'

const Account = () => <Layout>Account</Layout>

export default Account
